import { Trans } from "next-i18next";

import { useCheckIsMobile } from "@sellernote/shared/src/utils/hook";
import useOnceActivatedIntersectionObserver from "@sellernote/features/src/common/hooks/useOnceActivatedIntersectionObserver";

import DesktopHistoryList from "./DesktopHistoryList";
import MobileHistoryList from "./MobileHistoryList";
import Styled from "./index.styles";

export default function LandingSectionHistory() {
  const { isMobile } = useCheckIsMobile();

  const { target, isActivatedTarget } = useOnceActivatedIntersectionObserver({
    threshold: 0.3,
  });

  const historyItemClassName = `fade-up-animation ${
    isActivatedTarget ? "active" : ""
  }`;

  return (
    <Styled.containerWrapper ref={target}>
      <Styled.container>
        <h3>
          <Trans i18nKey="page-company:연혁섹션_타이틀" />
        </h3>

        <>
          {isMobile ? (
            <MobileHistoryList historyItemClassName={historyItemClassName} />
          ) : (
            <DesktopHistoryList historyItemClassName={historyItemClassName} />
          )}
        </>
      </Styled.container>
    </Styled.containerWrapper>
  );
}
